window.addEventListener('DOMContentLoaded', function () {
  const Swiper = window.Swiper;
  const carousel = document.querySelector('.testimonials-carousel');

  if (carousel) {
    new Swiper('.testimonials-carousel-mobile', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      autoHeight: true,

      pagination: {
        el: '.testimonials-carousel-mobile .swiper-pagination',
        clickable: true,
      },
    });

    new Swiper('.testimonials-carousel', {
      centeredSlides: true,
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 0,

      navigation: {
        prevEl: '.testimonials-carousel .swiper-button-prev',
        nextEl: '.testimonials-carousel .swiper-button-next',
      },

      pagination: {
        el: '.testimonials-carousel .swiper-pagination',
        clickable: true,
      },
    });
  }
});
